import React from 'react';
import { Navigation, useSidebarNav } from 'framework/navigation';
import AppSidebarNav from './AppSidebarNav';

interface Props {
  navigationConfig: Navigation;
  exceptions?: string[];
  [x: string]: unknown;
}

const SidebarNav = ({ navigationConfig, exceptions, ...rest }: Props) => {
  const { updateOpenMenuList, getNavigationItems, getHeaderMenuData, getSidebarItems } = useSidebarNav({
    navigationConfig,
    exceptions,
  });
  const items = getNavigationItems();

  return (
    <AppSidebarNav
      navConfig={{
        items,
        sidebarItems: getSidebarItems(items),
        headerMenuData: getHeaderMenuData(items),
        clickHandler: updateOpenMenuList,
      }}
      {...rest}
    />
  );
};

export default SidebarNav;
